module.exports = __webpack_public_path__ + "img/SKD.c4fc605a.png";